export const allOccurrences = ['daily', 'weekly', 'monthly', 'yearly'];
export type Occurrence = typeof allOccurrences[number];

export interface Recipient {
    email: string;
}
export interface UserRecipient extends Recipient {
    firstName: string;
    lastName: string;
    id: string;
}

export function isUserRecipient(recipient: Recipient): recipient is UserRecipient {
	return 'id' in recipient;
}

export interface Subscription {
    id: string;
    occurrence: Occurrence;
    recipient: Recipient;
    addedByUserId: string;
}
